import { currentMonth } from 'src/utils/currentMonth';
import { Entry } from '../Entry';

const today = new Date();

export const offlineEntriesMonthBeforeLast: Entry[] = [
  {
    id: 'uuid-16308',
    memo: 'Bread, butter and sausage',
    tagIds: ['uuid-2', 'uuid-6', 'wasd-123'],
    amount: -5.2, // -1500 HUF
    date: currentMonth(2, -2, today),
  },
  {
    id: 'uuid-74474',
    memo: 'Mortgage',
    tagIds: ['uuid-18', 'uuid-6'],
    amount: -305, // -110000 HUF
    date: currentMonth(8, -2, today),
  },
  {
    id: 'uuid-36127',
    memo: 'Weekend shopping',
    tagIds: ['uuid-2', 'uuid-7'],
    amount: -10.2, // -1500 HUF
    date: currentMonth(17, -2, today),
  },
  {
    id: 'uuid-36127123',
    memo: 'Grocery shopping',
    tagIds: ['uuid-2', 'uuid-8'],
    amount: -15, // -12500 HUF
    date: currentMonth(9, -2, today),
  },
  {
    id: 'uuid-361271234123',
    memo: 'Grocery shopping for dad',
    tagIds: ['uuid-2', 'uuid-8', 'uuid-19'],
    amount: -22, // -12500 HUF
    date: currentMonth(25, -1, today),
  },
  {
    id: 'uuid-74475',
    memo: 'Heating',
    tagIds: ['uuid-3', 'uuid-7'],
    amount: -9, // -2500 HUF
    date: currentMonth(5, -2, today),
  },
  {
    id: 'uuid-91735',
    memo: 'Electricity',
    tagIds: ['uuid-3', 'uuid-7'],
    amount: -12, // -8000 HUF
    date: currentMonth(6, -2, today),
  },
  {
    id: 'uuid-83483',
    memo: 'Logan',
    tagIds: ['uuid-10', 'uuid-7'],
    amount: -32, // -15000 HUF
    date: currentMonth(9, -2, today),
  },

  {
    id: 'uuid-8348312322',
    memo: 'Monday improv',
    tagIds: ['uuid-10', 'uuid-8'],
    amount: -42, // -15000 HUF
    date: currentMonth(12, -2, today),
  },
  {
    id: 'uuid-8348311123421',
    memo: 'Salary',
    tagIds: ['uuid-7'],
    amount: 2280, // 820000 HUF
    date: currentMonth(5, -2, today),
  },
  {
    id: 'uuid-83483111234212',
    memo: 'Revolut top up from bank account',
    tagIds: ['uuid-7', 'uuid-20', 'uuid-9'],
    amount: -700, // -250000 HUF
    date: currentMonth(6, -2, today),
  },
  {
    id: 'uuid-67355',
    memo: 'Gas (full tank)',
    tagIds: ['uuid-11', 'uuid-7'],
    amount: -48, // -15000 HUF
    date: currentMonth(8, -2, today),
  },
  {
    id: 'uuid-67355123123',
    memo: 'Train tickets',
    tagIds: ['uuid-11', 'uuid-6'],
    amount: -35, // -15000 HUF
    date: currentMonth(12, -2, today),
  },
  {
    id: 'uuid-6735512312311299',
    memo: 'Train tickets',
    tagIds: ['uuid-11', 'uuid-8'],
    amount: -4, // -750 HUF
    date: currentMonth(12, -2, today),
  },

  {
    id: 'uuid-55109',
    memo: 'Netflix',
    tagIds: ['uuid-4', 'uuid-7', 'uuid-10'],
    amount: -10.5, // -3800 HUF
    date: currentMonth(2, -2, today),
  },
  {
    id: 'uuid-551098',
    memo: 'Disney plus',
    tagIds: ['uuid-4', 'uuid-6', 'uuid-10'],
    amount: -8.9, // -3200 HUF
    date: currentMonth(2, -2, today),
  },
  {
    id: 'uuid-551091',
    memo: 'Spotify for mom',
    tagIds: ['uuid-4', 'uuid-6', 'uuid-19', 'uuid-10'],
    amount: -9.2, // -3300 HUF
    date: currentMonth(12, -2, today),
  },

  {
    id: 'uuid-95292',
    memo: "McDonald's (Drive-thru)",
    tagIds: ['uuid-7', 'uuid-5'],
    amount: -7.5, // -2350 HUF
    date: currentMonth(28, -2, today),
  },
  {
    id: 'uuid-952923',
    memo: "McDonald's (McChicken)",
    tagIds: ['uuid-6', 'uuid-5'],
    amount: -6.5, // -2350 HUF
    date: currentMonth(2, -2, today),
  },
  {
    id: 'uuid-952924',
    memo: 'Blu Agori Gyros',
    tagIds: ['uuid-6', 'uuid-5'],
    amount: -5.5, // -2350 HUF
    date: currentMonth(2, -2, today),
  },
  {
    id: 'uuid-95292412312',
    memo: 'Revolut-top up from bank account',
    tagIds: ['uuid-6', 'uuid-20', 'uuid-9'],
    amount: 695, // 250000 HUF
    date: currentMonth(6, -2, today),
  },
  {
    id: 'uuid-95292412312111288876',
    memo: 'Cash withdrawal from bank account',
    tagIds: ['uuid-8', 'uuid-20', 'uuid-9'],
    amount: 222, // 80000 HUF
    date: currentMonth(7, -2, today),
  },
  {
    id: 'uuid-9529241231233432',
    memo: 'Cash withdrawal from bank account',
    tagIds: ['uuid-7', 'uuid-20', 'uuid-9'],
    amount: -222, // -80000 HUF
    date: currentMonth(7, -2, today),
  },
];
